import { gql } from '@apollo/client'

// mutation name added
export default gql(`
    mutation batchCreateVirtualPublishRule($contents: [CreatePublishRuleInput] $project: String $module: String!) {
      batchCreateVirtualPublishRule(
          input: $contents 
          project: $project 
          module: $module 
        ) {
            id
            assetId
            group{
              id
            }
            isEnabled
            publishEndDate
            publishStartDate
          }
    }`
)
